// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1kwfm","fileDisabled":"File_fileDisabled__26jPz"};